import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ClipboardList, Download, RotateCcw, Loader2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

async function downloadPdf(r) {
  try {
    const res = await api.get(`/tools-tecnici/archivio/${r.id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a"); a.href = url; a.download = r.pdf_filename || `${r.tool}.pdf`; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch { toast.error("PDF non disponibile"); }
}

function Row({ r }) {
  const nav = useNavigate();
  return (
    <tr className="border-t border-border align-top" data-testid={`ct-row-${r.id}`}>
      <td className="py-2.5 pr-3 whitespace-nowrap">{r.created_at ? new Date(r.created_at).toLocaleString("it-IT") : "—"}</td>
      <td className="py-2.5 pr-3">{r.tool_label}</td>
      <td className="py-2.5 pr-3">
        {r.lead_exists ? <Link to={`/leads/${r.config_id}`} className="text-primary hover:underline" data-testid={`ct-link-${r.id}`}>Apri consulenza</Link> : <span className="text-muted-foreground">eliminata</span>}
        {r.da_ricalcolare && <Badge variant="outline" className="ml-2 border-amber-500 text-amber-600" data-testid={`ct-ricalcolare-${r.id}`}><AlertTriangle className="h-3 w-3 mr-1" />Da ricalcolare</Badge>}
      </td>
      <td className="py-2.5 pr-3">{r.cliente || "—"}</td>
      <td className="py-2.5 pr-3">{r.comune || "—"}</td>
      <td className="py-2.5 pr-3">{r.utente?.name || r.utente?.email || "—"}</td>
      <td className="py-2.5 pr-3 text-muted-foreground" data-testid={`ct-sintesi-${r.id}`}>{r.sintesi || "—"}</td>
      <td className="py-2.5 whitespace-nowrap space-x-2">
        <Button size="sm" variant="outline" disabled={!r.has_pdf} onClick={() => downloadPdf(r)} data-testid={`ct-pdf-${r.id}`}><Download className="h-4 w-4 mr-1" />Scarica PDF</Button>
        <Button size="sm" variant="outline" disabled={!r.lead_exists} onClick={() => nav(`/tools?tool=${r.tool}&lead=${r.config_id}`)} data-testid={`ct-reopen-${r.id}`}><RotateCcw className="h-4 w-4 mr-1" />Riapri</Button>
      </td>
    </tr>
  );
}

export default function ConsulenzeTecniche() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/tools-tecnici/archivio").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  return (
    <div className="space-y-6" data-testid="consulenze-tecniche-page">
      <div>
        <h1 className="font-heading font-bold text-2xl flex items-center gap-2"><ClipboardList className="h-6 w-6 text-primary" strokeWidth={1.5} /> Consulenze tecniche</h1>
        <p className="text-sm text-muted-foreground mt-1">Risultati salvati dagli strumenti tecnici di rete.torri.solar.</p>
      </div>
      <Card className="p-4 overflow-x-auto">
        {items === null ? <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /> : items.length === 0 ? (
          <p className="text-sm text-muted-foreground py-6 text-center" data-testid="ct-empty">Nessuna consulenza tecnica salvata.</p>
        ) : (
          <table className="w-full text-sm" data-testid="ct-table">
            <thead className="text-left text-xs uppercase tracking-wide text-muted-foreground">
              <tr><th className="pb-2 pr-3">Data</th><th className="pb-2 pr-3">Tool</th><th className="pb-2 pr-3">Consulenza</th><th className="pb-2 pr-3">Cliente</th><th className="pb-2 pr-3">Comune</th><th className="pb-2 pr-3">Utente</th><th className="pb-2 pr-3">Sintesi</th><th className="pb-2" /></tr>
            </thead>
            <tbody>{items.map((r) => <Row key={r.id} r={r} />)}</tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
